import React, { useState, useRef } from 'react';
import { useAlerts } from '../../context/AlertContext';
import AlertCustom from './AlertCustom';

const AlertsContainer: React.FC = () => {
    const { alerts, removeAlert } = useAlerts();
    let baseOffset = 0; // Inicializa useRef con el valor inicial del offset
    let previousTitle = ""; // Para almacenar el título anterior

    return (
        <div>
            {alerts.map((alert, index) => {
                // Restablecer baseOffset a 0 si el índice es 0
                baseOffset =(index === 0) ? 0: baseOffset +(previousTitle !== "" ? 88 : 64);  
                previousTitle = alert.title;

                return (
                <AlertCustom
                    key={alert.id}
                    id={alert.id}
                    offset={baseOffset} // Multiplica por index para que aparezcan una debajo de otra
                    removeAlert={removeAlert}
                    message={alert.message}
                    title={alert.title}
                    severity={alert.severity}
                />
                );
            })}
        </div>
    );
};

export default AlertsContainer;
